import React from "react";
import { Modal } from "react-bootstrap";
import Button from "../command/Button/Button";

interface PostRentalIDModalProps {
  show: boolean;
  storeName: string;
  onContinue: () => void;
  onHide: () => void;
  onCancel?: () => void;
}

const PostRentalIDModal: React.FC<PostRentalIDModalProps> = ({
  show,
  storeName,
  onContinue,
  onHide,
  onCancel,
}) => {
  return (
    <Modal
      show={show}
      aria-labelledby="post-rental-id-modal"
      centered
      onHide={onHide}
      className="verify-identity-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="post-rental-id-modal">Verify your ID in person</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="videntity-data">
          <p>
            You have chosen to verify your identity in person at{" "}
            <strong>{storeName}</strong>.
          </p>
          <p>
            Please bring a valid photo ID with you on the day of your rental.
            Your booking will proceed, and your identity will be verified at the
            store.
          </p>
          <ul>
            <li>UK Passport</li>
            <li>UK Driving Licence</li>
            <li>National Identity Card</li>
          </ul>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {onCancel && (
          <Button btnText="Go to Cart" onClick={onCancel} />
        )}
        <Button btnText="Continue" onClick={onContinue} />
      </Modal.Footer>
    </Modal>
  );
};

export default PostRentalIDModal;
